import React from 'react';
import {makeStyles} from '@material-ui/core/styles';
import {Container, Grid, List, ListItem, ListItemIcon, ListItemText, Paper, Typography} from '@material-ui/core';
import Link from "@material-ui/core/Link";
import {Link as RouterLink} from "react-router-dom";
import CheckIcon from '@material-ui/icons/Check';
import getCustomYear from "../../services/datetime/getCustomYear";

const useStyles = makeStyles(theme => ({
  paper: {
    marginTop: theme.spacing(2),
    padding: theme.spacing(2),
  },
  title: {
    padding: theme.spacing(1),
  }
}));

function Home(props) {
  const classes = useStyles();
  const currentStudyYear = getCustomYear(new Date());
  return (
    <Container maxWidth="xl">
      <Paper className={classes.paper}>
        <Grid container spacing={2} justifyContent="center">
          <Grid item xs={12}>
            <Grid container spacing={2} justifyContent="center">
              <Grid item xs={12}>
                <List>
                  <ListItem style={{ paddingBlock: '0'}}>
                    <ListItemText>
                      <Typography align="center" variant="h6" component="p" style={{ marginBlockEnd: '1rem'}}>Уважаемый
                        абитуриент {currentStudyYear}!</Typography>
                      <Typography align="justify" variant="body1" component="p" style={{ marginBlockEnd: '1rem'}}>
                      Гродненский государственный университет имени Янки Купалы приветствует вас и просит пройти регистрацию в Цифровом кабинете абитуриента.
                        
                      </Typography>
                      <Typography style={{ color: '#f50057', fontStyle: 'italic', fontWeight: '700'}}>Внимание! </Typography>
                      <Typography align="justify" variant="body1" component="p" style={{ fontStyle: 'italic',marginBlockEnd: '1rem'}}>
                      Регистрация иностранных граждан (поступающих на платную форму по результатам собеседования, устанавливающего уровень владения русским/английским языком) проводится в <Link variant="body2"
                       target="_blank" rel="noopener" href="https://recruit.grsu.by/"><strong>Цифровом кабинете абитуриента для иностранных граждан</strong></Link>
                      </Typography>
                      <Typography align="justify" variant="body1" component="p" style={{ fontWeight: '700'}}>
                        После регистрации в <span style={{textTransform: 'uppercase'}}>Цифровом кабинете абитуриента</span> Вы сможете:
                      </Typography>
                    </ListItemText>
                  </ListItem>
                  <ListItem style={{ paddingBlock: '0'}}>
                    <ListItemText>
                      <ListItem component={"div"}>
                        <ListItemIcon>
                          <CheckIcon color="primary"/>
                        </ListItemIcon>
                        <ListItemText>
                          <Typography variant="body1" component="p">
                            <strong>ЗАРЕГИСТРИРОВАТЬСЯ И ПРИНЯТЬ УЧАСТИЕ В УНИВЕРСИТЕТСКОЙ ОЛИМПИАДЕ ГРГУ ИМЕНИ ЯНКИ КУПАЛЫ</strong>
                          </Typography>
                        </ListItemText>
                      </ListItem>
                      <Typography align="justify" variant="body1" component="p">
                      Участниками многопрофильной университетской олимпиады являются учащиеся XI классов учреждений общего среднего образования. Победители многопрофильной университетской олимпиады имеют право на зачисление без вступительных испытаний в университет
при поступлении в год проведения олимпиады на специальность(и), соответствующие учебному предмету профильной олимпиады, согласно квоте по данной специальности, устанавливаемой Министерством образования.

                      </Typography>
                    </ListItemText>
                  </ListItem>
                  <ListItem>
                    <ListItemText>
                      <ListItem component={"div"}>
                        <ListItemIcon>
                          <CheckIcon color="primary"/>
                        </ListItemIcon>
                        <ListItemText>
                          <Typography variant="body1" component="p">
                            <strong>ПОЛУЧИТЬ КОНСУЛЬТАЦИЮ ПО
                              ВОПРОСАМ ПОСТУПЛЕНИЯ</strong>
                          </Typography>
                        </ListItemText>
                      </ListItem>
                      <Typography align="justify" variant="body1" component="p">
                        В режиме реального времени можно получить ответы на все интересующие
                        вопросы о порядке и условиях поступления на избранную специальность, об
                        организации учебного процесса на факультетах университета, о
                        студенческой жизни, о возможностях самореализации в науке, спорте,
                        творчестве и многое другое.
                      </Typography>
                    </ListItemText>
                  </ListItem>
                  <ListItem>
                    <ListItemText>
                      <ListItem component={"div"}>
                        <ListItemIcon>
                          <CheckIcon color="primary"/>
                        </ListItemIcon>
                        <ListItemText>
                          <Typography variant="body1" component="p">
                            <strong>ОТПРАВИТЬ ДОКУМЕНТЫ СО СВОЕГО
                              СМАРТФОНА ИЛИ КОМПЬЮТЕРА</strong>
                          </Typography>
                        </ListItemText>
                      </ListItem>
                      <Typography align="justify" variant="body1" component="p">
                        В заявление на поступление можно заранее внести все личные сведения,
                        сведения о полученном образовании, результаты централизованного экзамена и централизованного
                        тестирования
                        по соответствующим учебным предметам, сведения об имеющихся льготах, а
                        также
                        прикрепить скан- или фотокопии подтверждающих документов. Это позволит приемной комиссии университета провести
                        предварительную проверку документов, а затем Вы ЛИЧНО представите в
                        приемную
                        комиссию весь необходимый для участия в конкурсе пакет документов.
                      </Typography>
                    </ListItemText>
                  </ListItem>
                  <ListItem>
                    <ListItemText>
                      <ListItem component={"div"}>
                        <ListItemIcon>
                          <CheckIcon color="primary"/>
                        </ListItemIcon>
                        <ListItemText>
                          <Typography variant="body1" component="p">
                            <strong>ПОЛУЧИТЬ ИНФОРМАЦИЮ О ХОДЕ
                              ОБРАБОТКИ
                              ДОКУМЕНТОВ ПРИЕМНОЙ КОМИССИЕЙ</strong>
                          </Typography>
                        </ListItemText>
                      </ListItem>
                      <Typography align="justify" variant="body1" component="p">
                        В режиме реального времени можно получить информацию о ходе проверки
                        прикрепленных документов приемной комиссией университета и при наличии
                        замечаний привести их в полное соответствие с Правилами приема лиц для
                        получения общего высшего и специального высшего образования.
                      </Typography>
                    </ListItemText>
                  </ListItem>
                  <ListItem>
                    <ListItemText>
                      <ListItem component={"div"}>
                        <ListItemIcon>
                          <CheckIcon color="primary"/>
                        </ListItemIcon>
                        <ListItemText>
                          <Typography variant="body1" component="p">
                            <strong>РАСПЕЧАТАТЬ ЗАЯВЛЕНИЕ НА УЧАСТИЕ
                              В
                              КОНКУРСЕ И ДОГОВОР НА ОБУЧЕНИЕ</strong>
                          </Typography>
                        </ListItemText>
                      </ListItem>

                      <Typography align="justify" variant="body1" component="p">
                        После обработки документов приемной комиссией можно самостоятельно
                        распечатать заявление на участие в конкурсе по избранной специальности
                        (группе специальностей) и договоры на подготовку специалиста с высшим
                        образованием как за счет средств республиканского бюджета, так и на
                        платной основе.
                      </Typography>
                    </ListItemText>
                  </ListItem>
                  <ListItem>
                    <ListItemText>

                      <ListItem component={"div"}>
                        <ListItemIcon>
                          <CheckIcon color="primary"/>
                        </ListItemIcon>
                        <ListItemText>
                          <Typography variant="body1" component="p">
                            <strong>ЗАРЕГИСТРИРОВАТЬСЯ В ЭЛЕКТРОННОЙ
                              ОЧЕРЕДИ ДЛЯ ЛИЧНОЙ ПОДАЧИ ДОКУМЕНТОВ</strong>
                          </Typography>
                        </ListItemText>
                      </ListItem>

                      <Typography align="justify" variant="body1" component="p">
                        Выбрать удобное время для ЛИЧНОЙ подачи документов в приемную комиссию
                        университета.
                      </Typography>
                    </ListItemText>
                  </ListItem>
                  <ListItem>
                    <ListItemText>

                      <ListItem component={"div"}>
                        <ListItemIcon>
                          <CheckIcon color="primary"/>
                        </ListItemIcon>
                        <ListItemText>
                          <Typography variant="body1" component="p">
                            <strong>ПОЛУЧИТЬ ИНФОРМАЦИЮ О РЕЗУЛЬТАТАХ
                              СДАЧИ ВСТУПИТЕЛЬНЫХ ИСПЫТАНИЙ И ЗАЧИСЛЕНИЯ</strong>
                          </Typography>
                        </ListItemText>
                      </ListItem>

                      <Typography align="justify" variant="body1" component="p">
                        Сразу после внесения отметок в сводную ведомость можно узнать результаты
                        внутривузовских вступительных испытаний, а также получить информацию о
                        решении приемной комиссии по зачислению в число студентов Купаловского
                        университета.
                      </Typography>
                    </ListItemText>
                  </ListItem>
                </List>
              </Grid>

            </Grid>

          </Grid>
          {!props.isAuthenticated
            ?
            <>
              <Grid item>
                <Link component={RouterLink} to="/sign-up" variant="body2"
                      style={{textAlign: 'center'}}>
                  {/*<PersonAddIcon/>*/}
                  <Typography
                    variant="body1"
                  >
                    Нет учетной записи? Зарегистрироваться
                  </Typography>
                </Link>
              </Grid>
              <Grid item>
                <Link component={RouterLink} to="/sign-in" variant="body2"
                      style={{textAlign: 'center'}}>
                  {/*<ExitToAppIcon/>*/}
                  <Typography
                    variant="body1"
                  >
                    Уже есть аккаунт? Войти в систему
                  </Typography>
                </Link>
              </Grid>
            </>
            : null
          }
        </Grid>
      </Paper>
    </Container>
  );
}

export default Home;
